/**
 * overview 页面共有的单词
 */
export default {

  'overview_Key_Performance_Metrics': '关键指标',
  // 卡片标题和文字
  'overview_Revenue($)': '付费金额({unit})',
  'overview_New': '新进用户',
  'overview_ARPU($)': '活跃ARPU({unit})',
  'overview_Payer%': '付费渗透率',
  'overview_change': '变化率',
  'overview_change_amount': '变化量',


  // Engagement Metrics Trends
  'overview_Engagement_Metrics_Trends': '活跃指标',

  'overview_TRU': '总注册用户数', // 19
  'overview_PCU': '最高同时在线', // 20
  'overview_AOT(min)': '平均在线时长(分钟)', // 21
  'overview_Avg_Daily_Playtime(min)': '周日平均在线时长(分钟)',
  // segment组件指标解释： 日 WD2 WD3 WD7  周 WW2 WW3  月 WM2 WM3
  'overview_Weighted_D2': '第2天加权平均留存',
  'overview_Weighted_D3': '第3天加权平均留存',
  'overview_Weighted_D7': '第7天加权平均留存',
  'overview_Weighted_W2': '第2周加权平均留存',
  'overview_Weighted_W3': '第3周加权平均留存',
  'overview_Weighted_M2': '第2月加权平均留存',
  'overview_Weighted_M3': '第3月加权平均留存',

  // TODO: 无
  'overview_AOT': '平均在线时长',


  // Revenue Metrics Trends
  'overview_Revenue_Metrics_Trends': '收入指标', // 24
  'overview_metics_time_Trends': '在线时长指标', // 24

  'overview_ARPPU($)': '付费ARPPU({unit})', // 26
  'overview_Payer': '付费人数', // 28

  // Overall Performance 宽表
  'overview_Overall_Performance': '指标总体表现',
  'overview_close_progress': '关闭热力图',
  'overview_show_progress': '查看热力图',
  'overview_Setting': '设置',
  'overview_Date': '日期',

  'overview_ACU': '平均同时在线',
  'overview_New_Payer': '首次付费用户',
  'overview_Register_Payer': '新注册付费用户',
  'overview_Revenue(new_payer)': '首次付费用户金额',
  'overview_New_Users_ARPPU($)': '首次付费用户ARPPU({unit})',
  'overview_Avg.Login_Count': '平均登录次数',
  'overview_daily_Churn_Users': '日流失',
  'overview_weekly_Churn_Users': '周流失',
  'overview_monthly_Churn_Users': '月流失',
  'overview_Churn%': '流失率',

  // Breakdown 图表模块

  'overview_New_Users': '新进用户', // 2
  'overview_Retention_Users': '留存用户', // 3
  'overview_Return_Users': '回流用户', // 4
  'overview_Return_Daily': '日回流', // 4
  'overview_Return_Weekly': '周回流', // 4
  'overview_Return_Monthly': '月回流', // 4

  // Channels of New Users 图表模块
  'overview_Channels_of_New_Users': '新进用户渠道构成', // 5
  'overview_System_of_New_Users': '新进用户平台构成', // 5

  // Country/Region/Zone Breakdown 模块
  'overview_Country/Region/Zone_Breakdown': '国家/区域/区服排行榜', // 1
  'overview_Country': '国家', // 2
  'overview_Countries': '国家', // 2
  'overview_Region': '区域', // 3
  'overview_Regions': '区域', // 3
  'overview_Zone': '区服', // 4
  'overview_Zones': '区服', // 4
  'overview_of_Top_10': 'Top 10',


  'overview_Share_Of_All': '全局占比', // 7

  'overview_Revenue_of_Top_10_Countries': '付费金额 Top 10 国家', // 8
  'overview_Sum_Revenue($)': '总付费金额', // 9

  'overview_New_of_Top_10_Countries': '新进用户 Top 10 国家', // 10
  'overview_New_of_Top_10_Region': '新进用户 Top 10 区域', // 10
  'overview_New_of_Top_10_Zone': '新进用户 Top 10 区服', // 10
  'overview_Sum_New': '新进总数', // 11

  'overview_wow': '周环比',
  'overview_swlm': '上月同期',
  'overview_dod': '日环比',
  'overview_sdlw': '上周同期',
  'overview_mom': '月环比',
  'overview_smly': '去年同期',
  'overview_lost': '折损',

  // 待补充
  'overview_Last_Week': '上周同期',
  'overview_Today': '当天',
  'overview_Last_Month': '上月同期',
  'overview_This_Week': '当周',
  'overview_Last_Year': '去年同期',
  'overview_This_Month': '当月',

  // 其他:
  'overview_Revenue': '付费金额',
  'overview_ARPU': '活跃ARPU',
  'overview_Version': '版本',

  // overview 宽表
  'overview_sum_tip': '展示对应列的汇总值，部分指标(如总注册用户数、日活跃)不支持按用户去重统计将不展示。',

  // PC Console 模块
  'pc_overview_D1(T-1)': '次留(T-1)',
  'pc_overview_Revenue': '收入(剔除退款&税)',
  'pc_overview_Rev($)': '收入(剔除退款&税)({unit})',
  'pc_overview_Revenue($)': '收入(剔除退款&税)({unit})',
  'pc_overview_Units': '本体拷贝净销量',
  'pc_overview_sum_units': '总本体拷贝净销量',
  'pc_overview_DLC_MTX_Revenue': 'DLC & In-Game 收入',
  'pc_overview_MTX_Revenue': '内购收入',
  'pc_overview_MTX_Payer': '内购付费人数',
  'pc_overview_MTX_Payer_Rate': '内购付费渗透率',
  'pc_overview_DLC_MTX_ARPU': 'DLC & In-Game ARPU',
  'pc_overview_MTX_ARPU': '内购ARPU',
  'pc_overview_ARPPU': '付费ARPPU',
  'pc_overview_DLC_MTX_ARPPU': 'DLC & In-Game 付费ARPPU',
  'pc_overview_MTX_ARPPU': '内购付费ARPPU',
  'overview_Avg_PCU': '日平均最高同时在线',
  'pc_overview_Avg_MTX_Payer': '日平均内购付费人数',
  'overview_Avg_Payer': '日平均付费人数',
  'pc_overview_MTX': '内购交易次数',
  'pc_overview_DLC_Rev': 'DLC收入',
  'pc_overview_DLC_Revenue': 'DLC收入',
  'pc_overview_MTX_Rev': '内购收入({unit})',
  'pc_overview_Units_Rev': '本体拷贝收入',
  'pc_overview_Units_Rev($)': '本体拷贝收入({unit})',
  'pc_overview_Units_Revenue': '本体拷贝收入',
  'pc_overview_Digital_Rev': '线上收入',
  'pc_overview_Digital_Revenue': '线上收入',
  'pc_overview_Physical_Rev': '线下收入',
  'pc_overview_Physical_Revenue': '线下收入',
  'pc_overview_AVG_Login_Counts': '日平均登录数',
  'pc_overview_Entitlement': '拥有游戏用户数',
  'pc_overview_Time_to_Purchase': '购买时间间隔(天)',
  'pc_overview_Time_to_Purchase_Trend': '购买时间间隔',

  'nightingale_daily_revenue': '付费金额',
  'nightingale_daily_reactivated': '重新激活',
  'nightingale_daily_asp': '平均售价',
  'nightingale_daily_refunds': '退款',
  'nightingale_avg_asp': '平均售价',

  'nightingale_daily_asp$': '平均售价({unit})',
  'nightingale_daily_refunds$': '退款({unit})',
  'nightingale_avg_asp$': '平均售价({unit})',
  'nightingale_sum_refunds$': '退款总数({unit})',
  'nightingale_sum_reactivated': '重激活总数',


  'nightingale_daily_accumulated_units': '累计本体拷贝销售数',
  'nightingale_daily_refunded_units': '退款本体拷贝数',
  'nightingale_daily_accumulated_revenue': '累计收入',
  'nightingale_daily_avg_selling_price_asp': '平均售价',
  'nightingale_daily_new': '日新进',
  'nightingale_daily_sum_new': '新进总数',
  'nightingale_daily_reactivated_users': '日重激活',
  'nightingale_daily_median_online_time': '在线时长中位数',
  'nightingale_daily_avg_median_online_time': '平均在线时长中位数',
  'nightingale_daily_aot_hour': '平均在线时长',
  'nightingale_daily_above_2hr_users': '在线时长2小时以上用户数',
  'nightingale_daily_avg_above_2hr_users': '平均在线时长2小时以上用户数',
  'nightingale_daily_median_session_time': '会话时长中位数',
  'nightingale_daily_avg_median_session_time': '平均会话时长中位数',
  'nightingale_daily_avg_session_time': '日均会话时长',
  'nightingale_daily_avg_session_cnt': '用户日均会话数',
  'nightingale_daily_pcu_active_users_rate': '最高同时在线/日活跃',
  'nightingale_daily_avg_pcu_active_users_rate': '平均最高同时在线/平均日活跃',
  'nightingale_daily_acu': '平均同时在线',
  'nightingale_daily_stickiness': '粘性',
  'nightingale_avg_daily_stickiness': '平均粘性',
  'nightingale_daily_active_retention_d2t1': '活跃留存D1(T-1)',
  'nightingale_daily_active_retention_d8t7': '活跃留存D7(T-7)',

  // V2
  'pc_daily_v2_above_2hr_users': '在线时长2小时以上新进用户数',
  'pc_daily_v2_aot_hour': '平均在线时长',
  'pc_daily_v2_avg_above_2hr_users': '平均在线时长2小时以上新进用户数',
  'pc_daily_v2_median_session_time': '单个存档在线时长',
  'pc_daily_v2_avg_median_session_time': '平均单个存档在线时长',
  'pc_daily_v2_avg_session_time': '单个存档日均在线时长',
  'pc_daily_v2_avg_session_cnt': '日均登录存档个数',
  'pc_daily_v2_d1t1': '次留(T-1)',
  'pc_daily_v2_d2t2': '2留(T-2)',
  'pc_daily_v2_d7t7': '7留(T-7)',
  'pc_daily_v2_median_session_time_h': '单个存档在线时长(小时)',

  // V4
  'overview_monthly_breakdown_mtx_v4_platform': '净收入 平台',
  'overview_monthly_breakdown_mtx_v4_country': '净收入 Top 10 国家',
  'overview_monthly_breakdown_mtx_v4_region': '净收入 Top 10 区域',
  'pc_overview_Revenue_v4': '净收入',
  'pc_overview_Revenue_v4_total': '总净收入',

  // Calculation Bubble
  'data_calculation_specification': '数据计算规范',
  'bubble_completed': '已完成',
  'bubble_calculating': '计算中 ...',

  'pc_console_overall_tab': '总览',
  'pc_console_breakdown_tab': '每日细分',

  'overview_monthly_breakdown_dau_platform': '日活跃 平台',
  'overview_monthly_breakdown_mau_platform': '月活跃 平台',
  'overview_monthly_breakdown_wau_platform': '周活跃 平台',
  'overview_monthly_breakdown_new_platform': '新进用户 平台',

  'overview_monthly_breakdown_dau_country': '日活跃 Top 10 国家',
  'overview_monthly_breakdown_mau_country': '月活跃 Top 10 国家',
  'overview_monthly_breakdown_wau_country': '周活跃 Top 10 国家',
  'overview_monthly_breakdown_new_country': '新进用户 Top 10 国家',

  'overview_monthly_breakdown_dau_region': '日活跃 Top 10 区域',
  'overview_monthly_breakdown_mau_region': '月活跃 Top 10 区域',
  'overview_monthly_breakdown_wau_region': '周活跃 Top 10 区域',
  'overview_monthly_breakdown_new_region': '新进用户 Top 10 区域',

  'overview_monthly_breakdown_new_zone': '新进用户 Top 10 区服',

  'overview_monthly_breakdown_units_platform': '本体拷贝净销量 平台',
  'overview_monthly_breakdown_net_platform': '收入(剔除退款&税) 平台',
  'overview_monthly_breakdown_mtx_platform': '内购收入 平台',


  'overview_monthly_breakdown_units_country': '本体拷贝净销量 Top 10 国家',
  'overview_monthly_breakdown_net_country': '收入(剔除退款&税) Top 10 国家',
  'overview_monthly_breakdown_mtx_country': '内购收入 Top 10 国家',

  'overview_monthly_breakdown_units_region': '本体拷贝净销量 Top 10 区域',
  'overview_monthly_breakdown_net_region': '收入(剔除退款&税) Top 10 区域',
  'overview_monthly_breakdown_mtx_region': '内购收入 Top 10 区域',

  'pc_v2_avg_session_time': '单个存档日均在线时长(小时)',
  'pc_v2_avg_session_cnt': '日均登录存档个数',
  'pc_v2_daily_median_online_time': '在线时长中位数(小时)',

  'pc_v3_daily_avg_median_online_time': '平均在线时长',
  'pc_overview_table_mtx_revenue($)': '内购收入({unit})',

  // Overview Platform/Region/Country
  'gross_full_game_units_platform': '本体销量 平台',
  'gross_full_game_units_country': '本体销量 Top 10 国家',
  'gross_full_game_units_region': '本体销量 Top 10 区域',
  
  'gross_revenue_platform': '总收入 平台',
  'gross_revenue_country': '总收入 Top 10 国家',
  'gross_revenue_region': '总收入 Top 10 区域',
};
